import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { AddsuModel } from '../../addsu-models/addsu.models';

@Injectable({
  providedIn: 'root'
})
export class DsuAdService {

  private sessionStorageService = inject(SessionStorageService);

  async getAdvisordeclaration(uadsId: number) {

    const API_URL: string = environment.baseUrl + environment.apis.getdsuAnnualdecleration
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "UadsId": uadsId
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        // We just pass the raw array straight through!
        return JSON.stringify(httpResponse);
      })
      //  We catch any errors safely
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async saveVerifydeclarationquestion(saveDsuResponse: AddsuModel) {

    const API_URL: string = environment.baseUrl + environment.apis.saveverifydeclarationquestion
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: saveDsuResponse.toString()

    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        // We just pass the raw array straight through!
        return JSON.stringify(httpResponse);
      })
      //  We catch any errors safely
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getDropdownOptions() {

    const API_URL: string = environment.baseUrl + environment.apis.getDropdownOptions;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }


  async approvedeclarationquestion(uadsId: number) {

    const API_URL: string = environment.baseUrl + environment.apis.dsuapproveddecleartionquestion
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "annualDeclarationId": uadsId
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        // We just pass the raw array straight through!
        return JSON.stringify(httpResponse);
      })
      //  We catch any errors safely
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async submitapprovedeclarationquestion(repcode: string) {

    const API_URL: string = environment.baseUrl + environment.apis.submitdsuapproveddecleartionquestion
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        annualDeclarationId: 0,
        userPiasCode: repcode
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        // We just pass the raw array straight through!
        return JSON.stringify(httpResponse);
      })
      //  We catch any errors safely
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async returnDeclarationquestion(repcode: string) {

    const API_URL: string = environment.baseUrl + environment.apis.dsuReturnDeclarationquestion
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        annualDeclarationId: 0,
        userPiasCode: repcode
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        // We just pass the raw array straight through!
        return JSON.stringify(httpResponse);
      })
      //  We catch any errors safely
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async getDeclearionAttachements(data:any) {

    const API_URL: string = environment.baseUrl + environment.apis.dsugetAttachements
    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      responseType: 'blob',
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data:data
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        // We just pass the raw array straight through!
        return new Blob([httpResponse.data], {
          type: 'application/pdf'
        });
      })
      //  We catch any errors safely
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

}
